// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito+Sans);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound_main {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Nunito Sans";
  color: var(--primary-color);
  font-size: 1em;
  height: 100vh;
}

.notfound_main button {
  font-family: "Nunito Sans";
}

.notfound_main svg {
  width: 100%;
}

.title404 {
  font-size: 7.5em;
  margin: 15px 0px;
  font-weight: bold;
}

.title404 span {
  color: var(--secondary-color);
}

.subtitle404 {
  font-weight: bold;
  letter-spacing: 1px;
}

.backToHome {
  z-index: 1;
  overflow: hidden;
  background: transparent;
  position: relative;
  padding: 8px 30px;
  /* border-radius: 10px; */
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 2px;
  transition: 0.2s ease;
  font-weight: 600;
  margin: 5px 0px;
}

.backToHome.green {
  border: 1.5px solid var(--primary-color);
  color: var(--primary-color);
}

.backToHome.green:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 0%;
  height: 100%;
  background: var(--secondary-color);
  z-index: -1;
  transition: 0.2s ease;
}

.backToHome.green:hover {
  color: var(--white);
  border-color: var(--secondary-color);
  background: var(--secondary-color);
  transition: 0.2s ease;
}

.backToHome.green:hover:before {
  width: 100%;
}

.notfound_main #bone,
.notfound_main #tail {
  animation-name: flo;
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.blink_me {
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

@keyframes flo {
  50% {
    transform: translateY(30px);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/notfound.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Nunito+Sans\");\n\n.notfound_main {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Nunito Sans\";\n  color: var(--primary-color);\n  font-size: 1em;\n  height: 100vh;\n}\n\n.notfound_main button {\n  font-family: \"Nunito Sans\";\n}\n\n.notfound_main svg {\n  width: 100%;\n}\n\n.title404 {\n  font-size: 7.5em;\n  margin: 15px 0px;\n  font-weight: bold;\n}\n\n.title404 span {\n  color: var(--secondary-color);\n}\n\n.subtitle404 {\n  font-weight: bold;\n  letter-spacing: 1px;\n}\n\n.backToHome {\n  z-index: 1;\n  overflow: hidden;\n  background: transparent;\n  position: relative;\n  padding: 8px 30px;\n  /* border-radius: 10px; */\n  cursor: pointer;\n  font-size: 14px;\n  letter-spacing: 2px;\n  transition: 0.2s ease;\n  font-weight: 600;\n  margin: 5px 0px;\n}\n\n.backToHome.green {\n  border: 1.5px solid var(--primary-color);\n  color: var(--primary-color);\n}\n\n.backToHome.green:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 0%;\n  height: 100%;\n  background: var(--secondary-color);\n  z-index: -1;\n  transition: 0.2s ease;\n}\n\n.backToHome.green:hover {\n  color: var(--white);\n  border-color: var(--secondary-color);\n  background: var(--secondary-color);\n  transition: 0.2s ease;\n}\n\n.backToHome.green:hover:before {\n  width: 100%;\n}\n\n.notfound_main #bone,\n.notfound_main #tail {\n  animation-name: flo;\n  animation-duration: 5000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n.blink_me {\n  animation: blinker 1.5s linear infinite;\n}\n\n@keyframes blinker {\n  50% {\n    opacity: 0;\n  }\n}\n\n@keyframes flo {\n  50% {\n    transform: translateY(30px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
